/** @griffel:css-start [d] null **/
.f22iagw{display:flex;}
.f1vx9l62{flex-direction:column;}
.f13377fj{row-gap:var(--spacingVerticalL);}
.fcacm6k{padding-block-end:var(--spacingVerticalXL);}
.f1wn3y0l{row-gap:var(--spacingVerticalS);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f8ntp42{margin-block:0;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fkhj508{font-size:var(--fontSizeBase300);}
.f1i3iumi{line-height:var(--lineHeightBase300);}
.fl43uef{font-weight:var(--fontWeightSemibold);}
.f19n0e5{color:var(--colorNeutralForeground1);}
.fni485r{flex-wrap:wrap;}
.f122n59{align-items:center;}
.f1869bpl{justify-content:space-between;}
.fsnqrgy{column-gap:var(--spacingHorizontalS);}
.f778t4r{row-gap:var(--spacingVerticalXS);}
.f13qh94s{display:grid;}
.futfhg3{grid-template-columns:minmax(80px, auto) minmax(0, 1fr);}
.f1xcgk68{column-gap:var(--spacingHorizontalM);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f8ntp42{margin-block:0;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f11d4kpn{color:var(--colorNeutralForeground3);}
.fy9rknc{font-size:var(--fontSizeBase200);}
.f34sw2d{-webkit-margin-start:0;margin-inline-start:0;}
.fjksvth{overflow-wrap:anywhere;}
.f1fedwem{font-family:var(--fontFamilyMonospace);}
.f1c209jx{inline-size:100%;}
.f1hcrxcs{color:var(--colorPaletteRedForeground1);}
.f1noh358{row-gap:var(--spacingVerticalM);}
/** @griffel:css-end **/